import React, { useEffect, useState } from "react";
import { Modal, Tab } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Select from "react-select";
import swal from "sweetalert";
import { getData, AddUpdate ,getPostData } from "../../../ApiMethods/ApiMethods";
import axiosInstance from "../../../services/AxiosInstance";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const IncomeTransaction = () => {
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [orderStatus, setOrderStatus] = useState("authorized");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [postModal, setPostModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [form, setForm] = useState({
        TransactionCategory: "",
        TransactionType: "",
        Amt: "",
        Description: "",
        Comments: "",
        TransactionDateTime: "",
    });

    useEffect(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formattedToday = `${yyyy}-${mm}-${dd}`;
        setStartTime(formattedToday);
        setEndTime(formattedToday);
        fetchData(formattedToday, formattedToday, "authorized");
    }, []);

    const fetchData = async (FromDate, ToDate, payment_status) => {
        try {
            setLoading(true);
            const params = {
                FromDate,
                ToDate,
                payment_status: payment_status ?? null,
            };
            const res = await getPostData("PaymentHistory/GetData_PaymentStatus",params );
            setData(Array.isArray(res) ? res : []);
        } catch (error) {
            console.error(error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        fetchData(startTime, endTime, orderStatus);
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        try {
            const postData = {
                TransactionCategory: form.TransactionCategory,
                TransactionType: form.TransactionType,
                Amt: form.Amt,
                Description: form.Description,
                Comments: form.Comments,
                TransactionDateTime: form.TransactionDateTime,
            };

            await AddUpdate("PaymentHistory/Insert_PaymentHistory", postData);
            swal("Good job!", "Successfully Added", "success");
            setPostModal(false);
            fetchData(startTime, endTime, orderStatus);
        } catch (err) {
            console.error(err);
            swal("Oops", "Add failed", "error");
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const postData = {
                Id: editId,
                TransactionCategory: form.TransactionCategory,
                TransactionType: form.TransactionType,
                Amt: form.Amt,
                Description: form.Description,
                Comments: form.Comments,
                TransactionDateTime: form.TransactionDateTime,
            };

            await AddUpdate("PaymentHistory/Update_PaymentHistory", postData);
            swal("Good job!", "Successfully Updated", "success");
            setEditModal(false);
            fetchData(startTime, endTime, orderStatus);
        } catch (err) {
            console.error(err);
            swal("Oops", "Update failed", "error");
        }
    };

    const handleEditClick = async (row) => {
        setEditId(row?.payment_id || row?.payment_id || null);
        const openApiUrlInNewTab = (rawPath) => {
            if (!rawPath) return false;
            const replaced = String(rawPath).replace(/\\\\/g, '/').replace(/(^\s+|\s+$)/g, '');
            const originBase = (axiosInstance.defaults && axiosInstance.defaults.baseURL)
                ? String(axiosInstance.defaults.baseURL).replace(/\/api\/?$/i, '').replace(/\/$/, '')
                : window.location.origin;
            let final = replaced;
           
            if (/^https?:\/\//i.test(replaced)) {
                final = replaced;
            } else if (replaced.startsWith('/')) {
                final = `${originBase}${replaced}`;
            } else if (/^[^/]+\.[^/]+/.test(replaced)) {
             
                final = `https://${replaced}`;
            } else {
                final = `${originBase}/${replaced}`;
            }
            window.open(final, '_blank');
            return true;
        };
        try {
   
            try {
                const jsonRes = await axiosInstance.post("RazorPay/Invoice", { order_id: row?.payment_id }, { responseType: 'json' });
                const payload = jsonRes?.data;
                const possibleUrl = (typeof payload === 'string' ? payload : payload?.url || payload?.data || payload?.invoice_url || payload?.file_url);
                if (possibleUrl && typeof possibleUrl === 'string') {
                    if (openApiUrlInNewTab(possibleUrl)) return;
                }
            } catch (jsonErr) {
                console.debug('JSON attempt failed, falling back to arraybuffer', jsonErr);
            }

            
            const res = await axiosInstance.post("RazorPay/Invoice", { order_id: row?.payment_id }, { responseType: 'arraybuffer' });
            const contentType = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || '';
            if (contentType.toLowerCase().includes('pdf')) {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
               
                window.open(url, '_blank');
               
                setTimeout(() => window.URL.revokeObjectURL(url), 10000);
                return;
            }

            const text = new TextDecoder().decode(res.data);
            let parsed = null;
            try { parsed = JSON.parse(text); } catch (e) { parsed = null; }
            const possibleUrl = parsed?.url || parsed?.data || (typeof parsed === 'string' ? parsed : null);
            if (possibleUrl && typeof possibleUrl === 'string') {
                if (openApiUrlInNewTab(possibleUrl)) return;
            }

           
            const urlMatch = text.match(/https?:\/\/[^\s"']+/);
            if (urlMatch && urlMatch[0]) { if (openApiUrlInNewTab(urlMatch[0])) return; }

          
            try {
                const res2 = await AddUpdate("RazorPay/Invoice", { order_id: row?.payment_id });
                const maybeBase64 = res2?.data || res2?.data?.data || res2;
                if (typeof maybeBase64 === 'string') {
                    const base64 = maybeBase64.split(',').pop();
                    const byteChars = atob(base64);
                    const byteNumbers = new Array(byteChars.length);
                    for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    setTimeout(() => window.URL.revokeObjectURL(url), 10000);
                    return;
                }
            } catch (e) { console.error('Fallback invoice fetch failed', e); }

            swal('Oops', 'Unable to open invoice in new tab', 'error');
        } catch (err) {
            console.error('Invoice request failed', err);
            swal('Oops', 'Unable to fetch invoice', 'error');
        }
    };


    const columns = [
        { name: "Username", selector: (r) => r.Username || r.Username, sortable: true },
        { name: "payment_amount", selector: (r) => r.payment_amount, sortable: true },
        { name: "payment_status", selector: (r) => r.payment_status, sortable: true },
        { name: "CreatedDate", selector: (r) => r.CreatedDate, sortable: true },
      
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <button className="btn btn-sm btn-primary me-2" onClick={() => handleEditClick(row)}>Invoice</button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    return (
        <>
            <Tab.Container defaultActiveKey="All">
                <div className="main_card">
                    <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Income Transaction</h2>
                    <div className="row mt-3 align-items-end">
                        <div className="col-3">
                            <div className="form-group">
                                <label className="form-label">Start Time</label>
                                <input type="date" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label className="form-label">End Time</label>
                                <input type="date" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                            </div>
                        </div>
                       
                    </div>

                    <div className="d-flex align-items-center mt-3">
                        <label style={{ marginRight: "10px", color: "black", fontSize: "15px" }}>Payment Status:</label>
                        <div className="d-flex">
                            <label style={{ marginRight: "10px" }}>
                                <input type="radio" name="orderStatus" checked={orderStatus === "authorized"} onChange={() => setOrderStatus("authorized")} /> Authorized
                            </label>
                            <label style={{ marginRight: "10px" }}>
                                <input type="radio" name="orderStatus" checked={orderStatus === "captured"} onChange={() => setOrderStatus("captured")} /> Captured
                            </label>
                            <label style={{ marginRight: "10px" }}>
                                <input type="radio" name="orderStatus" checked={orderStatus === "failed"} onChange={() => setOrderStatus("failed")} /> Failed
                            </label>
                        </div>
                        <button style={{ marginLeft: "30px" }} className="btn btn-primary" onClick={handleSearch}>Search</button>
                    </div>
                </div>

                <div className="row main_card pt-0">
                    <div className="col-xl-12">
                        <div className="">
                            <div className=" p-0">
                                <div className="col-12 mt-2">
                                    {loading ? (
                                        <Loader />
                                    ) : (
                                        <DataTable dense data={data} columns={columns} selectableRowsHighlight pagination persistTableHead={true} noDataComponent={"There are no data to display"} customStyles={customStyles} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Tab.Container>

          
        </>
    );
};

export default IncomeTransaction;